module.exports = __webpack_public_path__ + "static/media/resend-logo.f39877ac.png";